import {gql} from '@apollo/client';

export const SEND_MESSAGE = gql`
    mutation sendMessage($input: SendMessageInput!){
        sendMessage(input: $input){
            _id
            channelId
            type
            message
            senderId
            read
            message
        }
    }
`